import type { ReactElement, ReactNode } from 'react';
import { useRef } from 'react';
import { NavLink } from 'react-router-dom';

type Props = {
  href: string;
  className?: string;
  reload?: boolean;
  'data-cy'?: string;
  target?: string;
  rel?: string;
  children: ReactNode;
};

function Link({
  href,
  className = 'c-nav-header__link',
  reload = false,
  'data-cy': dataCy = '',
  target,
  rel,
  children,
}: Props): ReactElement {
  const anchorElem = useRef();

  return (
    <li>
      {reload ? (
        <a
          className={className}
          data-cy={dataCy}
          href={href}
          target={target}
          rel={rel}
        >
          {children}
        </a>
      ) : (
        <NavLink
            // @ts-expect-error TODO: fix null safety
          ref={anchorElem}
          className={({ isActive }) => ([
            className,
            isActive ? 'is-active' : '',
          ].join(' '))}
          data-cy={dataCy}
          onClick={
            (e) => (e.target as HTMLElement).blur()
          }
          to={href}
        >
          {children}
        </NavLink>
      )}
    </li>
  );
}

export default Link;
